import type { TovVersionResponse } from "contracts/api/client-tov/version.responses";
import { TOV_VERSION_STATUS } from "contracts/enums/tov";
import { For, Show } from "solid-js";
import { relativeAge } from "../../ui/format";

// Version header spine: Profile -> Version -> status + activated, with one
// group-count chip per definition group so the model hierarchy reads at a glance.
export function VersionSpine(props: {
  profileName: string;
  version: TovVersionResponse;
  onActivate: () => void;
  onMap: () => void;
  mapping: boolean;
  mapLabel: string;
}) {
  const version = () => props.version;
  const counts = () => {
    const current = version();
    return [
      { label: "Traits", value: current.traits.length },
      { label: "Tone", value: current.toneDimensions.length },
      { label: "Rules", value: current.rules.length },
      { label: "Lexicon", value: current.lexicon.length },
      { label: "Examples", value: current.examples.length },
      { label: "Audiences", value: current.audiences.length },
      { label: "Pillars", value: current.contentPillars.length },
      { label: "Journeys", value: current.journeyStages.length },
      { label: "Channels", value: current.channels.length },
      { label: "Visual", value: current.visualGuidelines.length },
    ];
  };

  return (
    <section class="tov-spine card">
      <div class="tov-spine-head">
        <div class="tov-spine-path">
          <span class="tov-spine-profile">{props.profileName}</span>
          <span class="tov-spine-sep">▸</span>
          <span class="tov-spine-version">{version().label}</span>
          <span class={`tov-status tov-status-${version().status}`}>
            {version().status}
          </span>
        </div>
        <div class="tov-spine-meta">
          <Show when={version().activatedAt} fallback={<span>Draft</span>}>
            {(activatedAt) => (
              <span>Activated {relativeAge(new Date(activatedAt()))}</span>
            )}
          </Show>
          <Show when={version().status !== TOV_VERSION_STATUS.ACTIVE}>
            <button
              class="btn btn-primary"
              type="button"
              onClick={props.onActivate}
            >
              Activate version
            </button>
          </Show>
          <button
            class="btn"
            type="button"
            disabled={props.mapping}
            onClick={props.onMap}
          >
            {props.mapping ? "Mapping…" : props.mapLabel}
          </button>
        </div>
      </div>
      <p class="tov-spine-summary">{version().summary}</p>
      <div class="tov-counts">
        <For each={counts()}>
          {(entry) => (
            <span class="tov-count">
              <span class="tov-count-label">{entry.label}</span>
              <span class="tov-count-value mono">{entry.value}</span>
            </span>
          )}
        </For>
      </div>
    </section>
  );
}
